export enum Node_Type {
  PARAGRAPH = "PARAGRAPH",
  TEXT = "TEXT",
  HEADING = "HEADING",
  BULLETED_LIST = "BULLETED_LIST",
  ORDERED_LIST = "ORDERED_LIST",
  LIST_ITEM = "LIST_ITEM",
  BLOCKQUOTE = "BLOCKQUOTE",
  CODE_BLOCK = "CODE_BLOCK",
  VIDEO = "VIDEO",
  DIVIDER = "DIVIDER",
  FILE = "FILE",
  GALLERY = "GALLERY",
  GIF = "GIF",
  HTML = "HTML",
  IMAGE = "IMAGE",
  LINK_PREVIEW = "LINK_PREVIEW",
  /** MAP - @deprecated */
  MAP = "MAP",
  POLL = "POLL",
  APP_EMBED = "APP_EMBED",
  BUTTON = "BUTTON",
  COLLAPSIBLE_LIST = "COLLAPSIBLE_LIST",
  TABLE = "TABLE",
  EMBED = "EMBED",
  COLLAPSIBLE_ITEM = "COLLAPSIBLE_ITEM",
  COLLAPSIBLE_ITEM_TITLE = "COLLAPSIBLE_ITEM_TITLE",
  COLLAPSIBLE_ITEM_BODY = "COLLAPSIBLE_ITEM_BODY",
  TABLE_CELL = "TABLE_CELL",
  TABLE_ROW = "TABLE_ROW",
  EXTERNAL = "EXTERNAL",
  AUDIO = "AUDIO",
  CAPTION = "CAPTION",
  LAYOUT = "LAYOUT",
  LAYOUT_CELL = "LAYOUT_CELL",
  SHAPE = "SHAPE",
  CARD = "CARD",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Decoration_Type {
  BOLD = "BOLD",
  ITALIC = "ITALIC",
  UNDERLINE = "UNDERLINE",
  SPOILER = "SPOILER",
  ANCHOR = "ANCHOR",
  MENTION = "MENTION",
  LINK = "LINK",
  COLOR = "COLOR",
  FONT_SIZE = "FONT_SIZE",
  EXTERNAL = "EXTERNAL",
  STRIKETHROUGH = "STRIKETHROUGH",
  SUPERSCRIPT = "SUPERSCRIPT",
  SUBSCRIPT = "SUBSCRIPT",
  FONT_FAMILY = "FONT_FAMILY",
  UNRECOGNIZED = "UNRECOGNIZED",
}